// Fragment "Tenant 360 sections" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
// Backs super_admin/tenant360/sectionColumns.jsx and SectionsPanel.jsx (the drill-down tables
// under the section tiles): column headers the shared Global Data headers (gdv.h.*) do not
// have (t360s.h.*), one label per value of every closed vocabulary those tables show
// (t360s.v.<group>.<value>; a value the server adds later renders as its raw code), and the
// lock label of a tile the operator's role cannot read. Section names are t360.sec.*.
export default {
  fr: {
    "t360s.locked": "Accès restreint à votre rôle",
    "t360s.h.salesChannel": "Canal de vente",
    "t360s.h.nature": "Nature",
    "t360s.h.stock": "Stock",
    "t360s.h.trigger": "Déclencheur",
    "t360s.h.steps": "Étapes",
    "t360s.h.platforms": "Plateformes",
    "t360s.h.content": "Contenu",
    "t360s.h.scheduled": "Programmé le",
    "t360s.h.image": "Image",
    "t360s.h.context": "Contexte",
    "t360s.h.visitor": "Visiteur",
    "t360s.h.reference": "Référence",
    "t360s.h.refunded": "Remboursé",
    "t360s.v.productType.stripe": "Paiement en ligne",
    "t360s.v.productType.affiliate": "Affilié",
    "t360s.v.productNature.physical": "Physique",
    "t360s.v.productNature.digital": "Numérique",
    "t360s.v.stock.in": "En stock",
    "t360s.v.stock.out": "Rupture",
    "t360s.v.sequence.draft": "Brouillon",
    "t360s.v.sequence.active": "Active",
    "t360s.v.trigger.new_client": "Nouveau client",
    "t360s.v.trigger.booking_exists": "Rendez-vous existant",
    "t360s.v.trigger.booking_completed": "Rendez-vous terminé",
    "t360s.v.trigger.purchase_completed": "Achat finalisé",
    "t360s.v.trigger.no_activity": "Aucune activité",
    "t360s.v.trigger.pack_balance_hits": "Solde de forfait atteint",
    "t360s.v.trigger.tag_added": "Étiquette ajoutée",
    "t360s.v.trigger.nth_session_completed": "N-ième séance terminée",
    "t360s.v.trigger.review_moment": "Moment d'avis",
    "t360s.v.trigger.pathway_progress": "Progression du parcours",
    "t360s.v.trigger.pathway_completed": "Parcours terminé",
    "t360s.v.social.draft": "Brouillon",
    "t360s.v.social.scheduled": "Programmé",
    "t360s.v.social.published": "Publié",
    "t360s.v.image.yes": "Oui",
    "t360s.v.image.no": "Non",
    "t360s.v.context.patient": "Patient",
    "t360s.v.context.admin": "Praticien",
  },
  en: {
    "t360s.locked": "Not available to your role",
    "t360s.h.salesChannel": "Sales channel",
    "t360s.h.nature": "Type",
    "t360s.h.stock": "Stock",
    "t360s.h.trigger": "Trigger",
    "t360s.h.steps": "Steps",
    "t360s.h.platforms": "Platforms",
    "t360s.h.content": "Content",
    "t360s.h.scheduled": "Scheduled for",
    "t360s.h.image": "Image",
    "t360s.h.context": "Context",
    "t360s.h.visitor": "Visitor",
    "t360s.h.reference": "Reference",
    "t360s.h.refunded": "Refunded",
    "t360s.v.productType.stripe": "Online payment",
    "t360s.v.productType.affiliate": "Affiliate",
    "t360s.v.productNature.physical": "Physical",
    "t360s.v.productNature.digital": "Digital",
    "t360s.v.stock.in": "In stock",
    "t360s.v.stock.out": "Out of stock",
    "t360s.v.sequence.draft": "Draft",
    "t360s.v.sequence.active": "Active",
    "t360s.v.trigger.new_client": "New client",
    "t360s.v.trigger.booking_exists": "Booking exists",
    "t360s.v.trigger.booking_completed": "Booking completed",
    "t360s.v.trigger.purchase_completed": "Purchase completed",
    "t360s.v.trigger.no_activity": "No activity",
    "t360s.v.trigger.pack_balance_hits": "Pack balance reached",
    "t360s.v.trigger.tag_added": "Tag added",
    "t360s.v.trigger.nth_session_completed": "Nth session completed",
    "t360s.v.trigger.review_moment": "Review moment",
    "t360s.v.trigger.pathway_progress": "Pathway progress",
    "t360s.v.trigger.pathway_completed": "Pathway completed",
    "t360s.v.social.draft": "Draft",
    "t360s.v.social.scheduled": "Scheduled",
    "t360s.v.social.published": "Published",
    "t360s.v.image.yes": "Yes",
    "t360s.v.image.no": "No",
    "t360s.v.context.patient": "Patient",
    "t360s.v.context.admin": "Practitioner",
  },
  es: {
    "t360s.locked": "No disponible para tu rol",
    "t360s.h.salesChannel": "Canal de venta",
    "t360s.h.nature": "Naturaleza",
    "t360s.h.stock": "Stock",
    "t360s.h.trigger": "Disparador",
    "t360s.h.steps": "Pasos",
    "t360s.h.platforms": "Plataformas",
    "t360s.h.content": "Contenido",
    "t360s.h.scheduled": "Programada para",
    "t360s.h.image": "Imagen",
    "t360s.h.context": "Contexto",
    "t360s.h.visitor": "Visitante",
    "t360s.h.reference": "Referencia",
    "t360s.h.refunded": "Reembolsado",
    "t360s.v.productType.stripe": "Pago en línea",
    "t360s.v.productType.affiliate": "Afiliado",
    "t360s.v.productNature.physical": "Físico",
    "t360s.v.productNature.digital": "Digital",
    "t360s.v.stock.in": "En stock",
    "t360s.v.stock.out": "Agotado",
    "t360s.v.sequence.draft": "Borrador",
    "t360s.v.sequence.active": "Activa",
    "t360s.v.trigger.new_client": "Nuevo cliente",
    "t360s.v.trigger.booking_exists": "Cita existente",
    "t360s.v.trigger.booking_completed": "Cita completada",
    "t360s.v.trigger.purchase_completed": "Compra completada",
    "t360s.v.trigger.no_activity": "Sin actividad",
    "t360s.v.trigger.pack_balance_hits": "Saldo del pack alcanzado",
    "t360s.v.trigger.tag_added": "Etiqueta añadida",
    "t360s.v.trigger.nth_session_completed": "N.ª sesión completada",
    "t360s.v.trigger.review_moment": "Momento de reseña",
    "t360s.v.trigger.pathway_progress": "Progreso del recorrido",
    "t360s.v.trigger.pathway_completed": "Recorrido completado",
    "t360s.v.social.draft": "Borrador",
    "t360s.v.social.scheduled": "Programada",
    "t360s.v.social.published": "Publicada",
    "t360s.v.image.yes": "Sí",
    "t360s.v.image.no": "No",
    "t360s.v.context.patient": "Paciente",
    "t360s.v.context.admin": "Profesional",
  },
};
